import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderDivider, LabelValue } from "components";
import { RegistrationJourneyState } from "journey";

export const AddressDetails = ({
  candidateDetails,
}: {
  candidateDetails: NonNullable<RegistrationJourneyState["candidateDetails"]>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.addressTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.street.label")}
            value={candidateDetails.address.street}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.postalCode.label")}
            value={candidateDetails.address.postalCode}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.city.label")}
            value={candidateDetails.address.city}
          />
        </Grid>
      </Grid>
    </>
  );
};
